<template>
  <van-list
    v-model="loading"
    :finished="finished"
    finished-text=""
    @load="onLoad"
    :immediate-check="false"
    class="list-container"
    ref="vanList"
  >
    <div
      class="list-item"
      v-for="(item, index) in list"
      :key="index"
      @click="gotoOrderDetail(item)"
    >
      <div class="order-title">
        <div class="title-text">{{ item.staName }}</div>
        <div
          :class="
            item.orderStatus == 1
              ? 'charging'
              : item.orderStatus == 4
              ? 'error'
              : ''
          "
          class="order-status"
        >
          {{ item.orderStatusDesc }}
        </div>
      </div>
      <div class="order-info">
        <div class="order-item-box">
          <div class="item-name">订单号</div>
          <div class="item-value">{{ item.orderNo }}</div>
        </div>
        <div class="order-item-box">
          <div class="item-name">开始时间</div>
          <div class="item-value">{{ item.createTime }}</div>
        </div>
        <div class="order-item-box" v-if="item.chargeDurationDesc">
          <div class="item-name">时长</div>
          <div class="item-value">{{ item.chargeDurationDesc }}</div>
        </div>
        <div class="order-item-box" v-if="item.delayDurationDesc">
          <div class="item-name">延时</div>
          <div class="item-value">{{ item.delayDurationDesc }}</div>
        </div>
        <div class="order-item-box">
          <div class="item-name">电量</div>
          <div class="item-value black">{{ item.chargeElect }}kWh</div>
        </div>
        <div class="order-item-box red" v-if="item.orderStatus == 4">
          管理员将在24小时内为您处理，请耐心等待...
        </div>
      </div>

      <div class="order-money">
        <div class="order-money-flex">
          <template v-if="item.frozenAmount">
            订单冻结金额：{{ item.frozenAmount }}元
          </template>
        </div>
        <div class="v-center">
          <img
            class="order-vip"
            v-if="item.vipType == 3"
            src="../../../assets/img/ent-pay.png"
            alt=""
          />
          <img
            class="order-vip"
            v-if="item.vipType == 2"
            src="../../../assets/image/my-type-ent.png"
            alt=""
          />
          <span>总计(元)</span>
          <span class="money" :class="{ error: item.orderStatus == 4 }">{{
            item.chargeAmount != null ? item.chargeAmount : "-"
          }}</span>
          <span class="discount" v-if="item.discountAmount"
            >(优惠：{{ item.discountAmount }})</span
          >
        </div>
      </div>
    </div>
    <pi-no-list-data :list="list" text="暂无订单">
      <img
        src="@/picture/no-data-icon/order.png"
        class="no-list-icon"
      />
    </pi-no-list-data>
  </van-list>
</template>
<script>
import { List, Icon } from "vant";
import {
  pageOrder,
  getEntOrder,
} from "../../../common/api";
import { formatDate } from "../../../common/old/public/filters";
import noListData from "@/components/pi-no-list-data/pi-no-list-data.vue";
export default {
  name: "my-order-tab",
  components: {
    [List.name]: List,
    [Icon.name]: Icon,
    [noListData.name]: noListData,
  },
  props: {
    formData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    orderStatus: {
      type: String,
      default: "",
    },
    active: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
  },
  watch: {
    "formData.startDate": function () {
      if (this.value == this.active){
         this.resetFn();
      }else{
        this.list = []
      }
     
    },
    "formData.endDate": function () {
      if (this.value == this.active){
         this.resetFn();
      }else{
        this.list = []
      }
    },
    active: function () {
      let div = this.$refs.vanList.$el;
      this.scrollTop = div.scrollTop;
      if (this.value == this.active && this.list.length == 0) {
        this.requestListData();
      }
    },
  },
  data() {
    return {
      loading: false,
      ajaxLoading: false,
      form: {
        pageIndex: 1,
        pageSize: 10,
        orderStatus: "",
        endDate: "",
        startDate: "",
        vipType: "",
        entUserPkId: null,
        isEntPayOrder: null,
        accountPkId: ''
      },
      list: [],
      finished: false,
      scrollTop: 0,
    };
  },
  mounted() {
    this.$nextTick(()=>{
      this.requestListData();
    })
    
  },
  
  methods: {
    
    
    resetFn() {
      this.form.pageIndex = 1;
      this.form.pageSize = 10;
      this.scrollTop = 0;
      // this.finished = false;
      this.list = [];
      this.requestListData();
    },
    onLoad() {
      if (!this.finished && !this.ajaxLoading) {
        this.form.pageIndex++;
        this.requestListData();
      }
    },
    requestListData() {
      let that = this;
      this.ajaxLoading = true;
      let json = JSON.parse(JSON.stringify(this.form));
      json = Object.assign(json,this.formData)
      json.endDate = formatDate(this.formData.endDate);
      json.startDate = formatDate(this.formData.startDate);
      json.orderStatus = this.orderStatus == "0" ? null : this.orderStatus;
      let ajaxOrder = null;
      if (this.formData.entUserPkId) {
        ajaxOrder = getEntOrder(json, that.list.length == 0);
      } else {
        ajaxOrder = pageOrder(json, that.list.length == 0);
      }
      ajaxOrder
        .then((data) => {
          if (data.data && data.status == 0) {
            that.list = that.list.concat(data.data);
            that.finished = data.total <= that.list.length;
          } else {
            this.$toast(data.msg);
            this.finished = true;
          }
          this.ajaxLoading = false;
          this.loading = false;
        })
        .catch((error) => {
          this.finished = true;
          this.ajaxLoading = false;
          this.$toast(error);
        });
    },

    gotoOrderDetail(item) {
      if (item.orderStatus === 4 && !this.form.entUserPkId) {
        //异常
        this.$router.push({
          name: "pay-success",
          query: {
            orderNo: item.orderNo,
          },
          params: {
            payInfo: {
              orderNo: item.orderNo,
              staAddress: item.staAddress,
              staName: item.staName,
            },
            payResult: false,
          },
        });
      } else if (item.orderStatus === 5) {
        //待支付
        this.$router.replace({
          name: "order-not-pay",
          query: {
            accountPkId: this.$route.query.accountPkId,
            gunNumber: item.gunNumber,
            serialNumber: item.serialNumber,
            orderNo: item.orderNo,
            replace: true,
          },
        });
      } else if (item.orderStatus === 6) {
        //充电完成
        this.$router.push({
          name: "my/order/details",
          query: { orderNo: item.orderNo },
        });
      } else if (item.orderStatus === 1) {
        //正在充电
        this.$router.replace({
          name: "charge/charging",
          query: {
            accountPkId: item.accountPkId,
            gunNumber: item.gunNumber,
            serialNumber: item.serialNumber,
            orderNo: item.orderNo,
            replace: true,
          },
        });
      } else {
        //充电完成
        this.$router.push({
          name: "my/order/details",
          query: { orderNo: item.orderNo },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.list-container {
  flex: 1;
  overflow-y: auto;
  background-color: #efeff4;
}

.list-item {
  background-color: #fff;
  margin-top: 0.1rem;
  font-size: 0.28rem;
  line-height: 0.4rem;
  .order-title {
    padding: 0.2rem;
    border-bottom: 1px solid #efeff4;
    display: flex;
    .title-text {
      flex: 1;
      color: #000;
      font-weight: bold;
    }
    .order-status {
      color: #576b95;
    }
    .order-status.charging {
      color: #14cc80;
    }
    .order-status.error {
      color: #f95450;
    }
  }
  .order-info {
    padding: 0.1rem 0.2rem;
    color: #666666;
    .order-item-box {
      display: flex;
      margin-top: 0.1rem;
      .item-name {
        flex: 1;
      }
      .item-value {
        color: #999999;
      }
      .item-value.black {
        color: #000;
      }
    }
  }

  // .item-order-sn {
  //   display: flex;
  //   padding-bottom: 0.2rem;
  //   color: #999;
  //   .order-sn {
  //     flex: 1;
  //     color: #000000;
  //     font-size: 0.28rem;
  //     line-height: 0.4rem;
  //   }
  //   .order-status {
  //     font-size: 0.24rem;
  //     line-height: 0.33rem;

  //     padding-top: 0.04rem;
  //   }
  // }
  // .order-info {
  //   margin-top: 0.01rem;
  //   padding: 0.1rem 0;
  //   .sta-name {
  //     font-size: 0.28rem;
  //     line-height: 0.4rem;
  //     color: #666;
  //     .vip {
  //       float: right;
  //       font-size: 0.24rem;
  //       line-height: 0.33rem;
  //       color: #999;
  //     }
  //     img {
  //       width: 1rem;
  //     }
  //   }
  //   .order-time {
  //     font-size: 0.24rem;
  //     line-height: 0.33rem;
  //     color: #999;
  //     margin-top: 0.1rem;
  //   }
  //   .order-dl {
  //     margin-top: 0.1rem;
  //     font-size: 0.28rem;
  //     line-height: 0.4rem;
  //     color: #666;
  //     .dl {
  //       color: #000;
  //       font-size: 0.28rem;
  //       line-height: 0.4rem;
  //     }
  //   }
  // }
  .order-money {
    padding: 0.2rem 0.2rem;
    // text-align: right;
    font-size: 0.28rem;
    line-height: 0.56rem;
    color: #666;
    display: flex;
    border-top: 1px solid #efeff4;
    .order-money-flex {
      flex: 1;
    }
    .order-vip {
      width: 0.96rem;
      height: 0.3rem;
    }
    .money {
      color: #14cc80;
      font-size: 0.4rem;
    }
    .money.error {
      color: #e64340;
    }
  }
  .discount {
    font-size: 0.28rem;
    color: #666;
  }
}
.list-item:active {
  background-color: #f5f5f5;
}
</style>
